import $ = require("jquery");
import ko = require("knockout");
import _ = require("underscore");
import svc = require("../Atlas/Service");
import unls = require("../Atlas/UsernameLookupService");

export = UserGroupPicker;


namespace UserGroupPicker {

    export interface IResolvedUser extends unls.IResolvedUser { }

    export interface IUserGroupPickerParams {
        shouldHaveAddButton?: boolean;
        addNewUser?: (resolvedUser: IResolvedUser, afterAdd: (err: any) => void) => void;
        externalVm?: any;
        netId?: KnockoutObservable<string>;
        isValid?: KnockoutObservable<boolean>;
        netIdValidationMessage?: KnockoutObservable<string>;
        resolvedUser?: KnockoutObservable<IResolvedUser>;
        netIdFocused?: KnockoutObservable<boolean> | boolean;
        netIdLookupUrl?: string;
        realms?: IRealmDescription[];
        forcedRealm?: string;
        selectedRealm?: KnockoutObservable<string>;
        placeholderText?: KnockoutObservable<string>;
        userInputLabel?: KnockoutObservable<string>; //Custom label to place on the user group input field
        domainSelectLabel?: KnockoutObservable<string>; //Custom label to place on the domain select input field
        userEntityType?: KnockoutObservable<string>; //e.g. Administrators, Group Members, Participants.  What am I adding this user to?  To help with labels.
        inputGroupLabel?: KnockoutObservable<string>; //Custom fieldset legend for the user group picker inputs
        displayGroupLabel: KnockoutObservable<boolean>; //display (or not) the inputGroupLabel fieldset legend for the component
        groupLabelCssClasses: KnockoutObservable<string>; //when displaying the group label, what classes to add to the fieldset legend
        resolutionIdSuffix?: KnockoutObservable<string>; //Added to the end of the id of the resolved info.  Needed when multiple components appear on the same page.  We used aria-described by so user sees results during input which needs an id.
    }

    export interface IRealm extends IRealmDescription { }
    export interface IAvailableActiveDirectoryRealms {
        DefaultRealm: string;
        Realms: IRealmDescription[];
    }

    export class UsernameUtils {
        static parseRealm(netId: string) {
            if (netId) {
                netId = netId.trim().toLowerCase();
                let atSymbolIndex = netId.lastIndexOf("@");
                if (atSymbolIndex > -1 && atSymbolIndex < (netId.length - 1)) {
                    let realm = netId.substring(atSymbolIndex + 1);
                    return realm.trim();
                }
            }
            return null;
        }
        static stripAllDomainInformationFromNetId(input: string) {
            if (!input) {
                return input;
            }
            let idx = input.indexOf("\\");
            if (idx > -1) {
                input = input.substring(idx + 1);
            }
            idx = input.indexOf("/");
            if (idx > -1) {
                input = input.substring(idx + 1);
            }
            idx = input.indexOf("@");
            if (idx > -1) {
                input = input.substring(0, idx);
            }
            return input.trim();
        }
    }
 

    export class UserGroupPickerViewModel {
        public shouldHaveAddButton: boolean = false;
        private externalVm: any;
        public netId: KnockoutObservable<string>;
        private isValid: KnockoutObservable<boolean>;
        public netIdValidationMessage: KnockoutObservable<string>;
        public netIdFocused: KnockoutObservable<boolean>;
        private resolvedUser: KnockoutObservable<IResolvedUser>;
        private addCallback: (resolvedUser: IResolvedUser, afterAdd: (err) => void) => void;
        private netIdLookupUrl: string;
        private realms: IRealmDescription[];
        private realmMap: { [realm: string]: IRealmDescription};
        private forcedRealm: string;
        public selectedRealm: KnockoutObservable<string>;
        public placeholderText: KnockoutObservable<string>;
        public userInputLabel: KnockoutObservable<string>;
        public domainSelectLabel: KnockoutObservable<string>;
        public userEntityType: KnockoutObservable<string>;
        public inputGroupLabel: KnockoutObservable<string>;
        public displayGroupLabel: KnockoutObservable<boolean>;
        public groupLabelCssClasses: KnockoutObservable<string>;
        public resolutionIdSuffix: KnockoutObservable<string>;

        private usingMultipleRealms: boolean;

        public resolvedName: KnockoutComputed<string>;
        public resolvedType: KnockoutComputed<string>;
        public addUserEnabled: KnockoutComputed<boolean>;
        public isUser: KnockoutComputed<boolean>;
        public isGroup: KnockoutComputed<boolean>;
        public hasError: KnockoutComputed<boolean>;
        public showResolving: KnockoutComputed<boolean>;
        public showInitialState: KnockoutComputed<boolean>;
        public addButtonLabel: KnockoutComputed<string>;
        public resolvedTitle: KnockoutComputed<string>;

        constructor(params: IUserGroupPickerParams) {
            if (params && params.addNewUser) {
                this.addCallback = params.addNewUser;
                this.shouldHaveAddButton = true;
            }

            if (params && params.netIdLookupUrl) {
                this.netIdLookupUrl = params.netIdLookupUrl;
            } else {
                this.netIdLookupUrl = svc.globalPageData().urls.resolveNetId;
            }

            if (params && params.shouldHaveAddButton !== undefined && params.shouldHaveAddButton !== null && typeof params.shouldHaveAddButton === "boolean") {
                this.shouldHaveAddButton = params.shouldHaveAddButton;
            }

            if (params && params.externalVm) {
                params.externalVm(this);
            }

            if (params && params.netId && ko.isObservable(params.netId)) {
                this.netId = params.netId;
            } else {
                this.netId = ko.observable<string>();
            }

            if (params && params.isValid && ko.isObservable(params.isValid)) {
                this.isValid = params.isValid;
            } else {
                this.isValid = ko.observable(false);
            }

            if (params && params.netIdValidationMessage && ko.isObservable(params.netIdValidationMessage)) {
                this.netIdValidationMessage = params.netIdValidationMessage;
            } else {
                this.netIdValidationMessage = ko.observable("");
            }

            if (params && params.resolvedUser && ko.isObservable(params.resolvedUser)) {
                this.resolvedUser = params.resolvedUser;
            } else {
                this.resolvedUser = ko.observable<IResolvedUser>();
            }

            if (params && params.netIdFocused !== undefined) {
                this.netIdFocused = ko.isObservable(params.netIdFocused) ? params.netIdFocused as KnockoutObservable<boolean> : ko.observable(params.netIdFocused as boolean);
            } else {
                this.netIdFocused = ko.observable(true);
            }

            if (params && params.realms && params.realms.length) {
                this.realms = params.realms;
                this.usingMultipleRealms = true;
                this.realmMap = {};
                for (let r of this.realms) {
                    this.realmMap[r.Realm.toLowerCase()] = r;

                }
            } else {
                this.realms = null;
                this.usingMultipleRealms = false;
            }

            if (!this.usingMultipleRealms) {
                if (params && params.forcedRealm) {
                    this.forcedRealm = params.forcedRealm;
                }
            }


            if (params && this.usingMultipleRealms && params.selectedRealm && ko.isObservable(params.selectedRealm)) {
                this.selectedRealm = params.selectedRealm;
            } else {
                this.selectedRealm = ko.observable(null);
            }

            if (params.placeholderText) {
                this.placeholderText = params.placeholderText;
            } else {
                this.placeholderText = ko.observable('User NetId or Group Name');
            }

            if (params.userInputLabel) {
                this.userInputLabel = params.userInputLabel;
            } else {
                this.userInputLabel = ko.observable("User NetId or Group Name");
            }

            if (params.userEntityType) {
                if (ko.isObservable(params.userEntityType))
                    this.userEntityType = params.userEntityType;
                else
                    this.userEntityType = ko.observable(params.userEntityType);
            } else {
                this.userEntityType = ko.observable("");
            }

            if (params.inputGroupLabel) {
                if (ko.isObservable(params.inputGroupLabel))
                    this.inputGroupLabel = params.inputGroupLabel;
                else
                    this.inputGroupLabel = ko.observable(params.inputGroupLabel);
            } else {
                let txt = `User Group Picker${this.userEntityType() ? " for " + this.userEntityType() : ""}`;
                this.inputGroupLabel = ko.observable(txt);
            }

            if (params.domainSelectLabel) {
                if (ko.isObservable(params.domainSelectLabel))
                    this.domainSelectLabel = params.domainSelectLabel;
                else
                    this.domainSelectLabel = ko.observable(params.domainSelectLabel);
            } else {
                this.domainSelectLabel = ko.observable("Domain");
            }

            if (params.displayGroupLabel) {
                if (ko.isObservable(params.displayGroupLabel))
                    this.displayGroupLabel = params.displayGroupLabel;
                else
                    this.displayGroupLabel = ko.observable(params.displayGroupLabel);
            } else {
                this.displayGroupLabel = ko.observable(false);
            }

            if (params.groupLabelCssClasses && this.displayGroupLabel()) {
                if (ko.isObservable(params.groupLabelCssClasses))
                    this.groupLabelCssClasses = params.groupLabelCssClasses;
                else
                    this.groupLabelCssClasses = ko.observable(params.groupLabelCssClasses);
            } else { //if displaying the legend, default to label class otherwise visually hide
                if (this.displayGroupLabel())
                    this.groupLabelCssClasses = ko.observable("label");
                else
                    this.groupLabelCssClasses = ko.observable("sr-only");
            }

            if (params.resolutionIdSuffix) {
                if (ko.isObservable(params.resolutionIdSuffix))
                    this.resolutionIdSuffix = params.resolutionIdSuffix;
                else
                    this.resolutionIdSuffix = ko.observable(params.resolutionIdSuffix);
            } else { //default to empty ... there should only be one control on the page in this case
                this.resolutionIdSuffix = ko.observable("");
            }
            
            this.resolvedName = ko.pureComputed(() => {
                var usr = this.resolvedUser();
                if (usr) {
                    return usr.DisplayName;
                }
                return null;
            });

            this.resolvedTitle = ko.pureComputed(() => {
                var usr = this.resolvedUser();
                if (usr) {
                    return usr.EmployeeTitle;
                }
                return null;
            })
            this.resolvedType = ko.pureComputed(() => {
                var usr = this.resolvedUser();
                if (usr) {
                    return usr.Type;
                }
                return null;
            });

            this.addUserEnabled = ko.computed(() => {
                var retVal = this.successfulResolution() && !this.addingUser();
                this.isValid(retVal);
                return retVal;
            });

            this.isUser = ko.pureComputed(() => {
                return this.userIsType("User");
            });

            this.isGroup = ko.pureComputed(() => {
                return this.userIsType("Group");
            });

            this.hasError = ko.pureComputed(() => {
                if (!this.successfulResolution() && this.netId() && !this.resolving() && this.showStatus()) {
                    return true;
                }
                return false;
            });
            this.showResolving = ko.pureComputed(() => {
                return this.showQuickStatus() && (this.resolving() || (this.netId() && !this.showStatus() && !this.successfulResolution()));
            });
            this.showInitialState = ko.pureComputed(() => {
                return !this.hasError() && !this.showResolving() && !this.successfulResolution();
            });
            this.addButtonLabel = ko.pureComputed(() => {
                let toText = "";
                if (this.userEntityType()) {
                    toText = " to " + this.userEntityType();
                }
                return !this.addingUser() ? "Add " + this.resolvedName() + toText : "Update " + this.resolvedName();
            });
            this.initComponent();
        }

        public successfulResolution = ko.observable(false);
        private showStatus = ko.observable(true);
        private showQuickStatus = ko.observable(false);
        private resolving = ko.observable(false);
        public addingUser = ko.observable(false);
        public invalidGroupType = ko.observable(false);


        private userIsType(userType: string) {
            var usr = this.resolvedUser();
            if (usr) {
                return usr.Type === userType.toString();
            }
            return false;
        }

        public resetEditor() {
            this.successfulResolution(false);
            this.resolvedUser(null);
            this.netId(null);
            this.addingUser(false);
            this.netIdFocused(true);
            this.invalidGroupType(false);
        }

        public addUser() {
            if (this.addCallback) {
                if (ko.unwrap(this.successfulResolution)) {
                    this.addingUser(true);
                    this.addCallback(ko.unwrap(this.resolvedUser), (err) => {
                        if (!err) {
                            this.resetEditor();
                        }
                        this.addingUser(false);
                    });
                }
            }
        }
        
        private setDisplayText(user: IResolvedUser) {
            this.resolving(false);
            if (user) {
                if (user.Type !== "Group" || !user.IsDistributionGroup) {
                    this.resolvedUser(user);
                    this.successfulResolution(true);
                    return;
                }

                this.invalidGroupType(true);
            }
       
            this.resolvedUser(null);
            this.successfulResolution(false);
        }

        private initComponent() {
            var vm = this;
            var netIds: { [s: string]: IResolvedUser } = {};
            var lookupXhr: JQueryXHR = null;

            function actuallyLookupValue() {
                vm.resolving(true);
                var netId = ko.unwrap(vm.netId);
                var cacheKey = netId;
                if (vm.usingMultipleRealms) {
                    cacheKey = cacheKey + "@" + ko.unwrap(vm.selectedRealm);
                } else if (vm.forcedRealm) {
                    cacheKey = cacheKey + "@" + vm.forcedRealm;

                }

                if (netId) {
                    if (typeof (netIds[cacheKey]) !== "undefined") {
                        vm.setDisplayText(netIds[cacheKey]);
                    } else {
                        if (lookupXhr) {
                            lookupXhr.abort();
                            lookupXhr = null;
                        }
                        var params:any = { netIdOrGroup: netId };
                        if (vm.usingMultipleRealms){
                            params.realm = ko.unwrap(vm.selectedRealm);
                        } else if (vm.forcedRealm) {
                            params.realm = vm.forcedRealm;
                        }


                        lookupXhr = $.get(vm.netIdLookupUrl, params);
                        lookupXhr.done((result, status, jqxhr) => {
                            if (jqxhr === lookupXhr) {
                                if (result && result.Successful) {
                                    netIds[cacheKey] = result.Data;
                                } else {
                                    netIds[cacheKey] = null;
                                }
                                vm.setDisplayText(netIds[cacheKey]);
                            }
                        });
                        lookupXhr.fail((result) => {
                            vm.setDisplayText(null);
                            vm.netIdValidationMessage(result.responseJSON ? result.responseJSON.Content : null);
                        });
                    }
                } else {
                    vm.setDisplayText(null);
                }
            }


            var lookupValueDebounced = _.throttle(actuallyLookupValue, 200);
            var lookupValue = (x) => {
                this.resolving(true);
                lookupValueDebounced();
            }




            var updateTimeout: number;
            var quickStatusUpdateTimeout: number;
            ko.computed(() => {
                this.showStatus(false);
                this.showQuickStatus(false);
                this.invalidGroupType(false);
                if (updateTimeout) {
                    clearTimeout(updateTimeout);
                }
                if (quickStatusUpdateTimeout) {
                    clearTimeout(quickStatusUpdateTimeout);
                }
                updateTimeout = window.setTimeout(() => {
                    this.showStatus(true);
                }, 1000);
                quickStatusUpdateTimeout = window.setTimeout(() => {
                    this.showQuickStatus(true);
                }, 600);

                var value = this.netId();
                if (this.usingMultipleRealms) {

                    // handle input for user@realm.com and auto-select matching realm from ddl, if possible
                    let parsedCn = UsernameUtils.stripAllDomainInformationFromNetId(value);
                    let parsedRealm = UsernameUtils.parseRealm(value);
                    if (parsedRealm) {
                        let r = this.realmMap[parsedRealm];
                        if (r) {
                            value = parsedCn;
                            //console.log(`found user@realm being set in input box.  Setting netId to be ${parsedCn} and realm to be ${r.Realm}`);
                            this.netId(parsedCn);
                            this.selectedRealm(r.Realm);
                        }
                    }

                    value = value + "@" + this.selectedRealm();
                } else if (this.forcedRealm) {

                    // handle input for user@forcedRealm and strip realm, if possible.
                    let parsedCn = UsernameUtils.stripAllDomainInformationFromNetId(value);
                    let parsedRealm = UsernameUtils.parseRealm(value);
                    if (parsedRealm) {
                        //console.log(`found user@realm being set in input box.  Checking if '${parsedCn}' @ '${parsedRealm}' matches forcedRealm of "${this.forcedRealm}"`);
                        if (parsedRealm === this.forcedRealm.toLowerCase()) {
                            value = parsedCn;
                            this.netId(parsedCn);
                            //console.log(`Success!  Setting netId to be ${parsedCn}`);
                        }
                    }


                    value = value + "@" + this.forcedRealm;
                }
                if (value) {
                    lookupValue(value);
                } else {
                    this.resetEditor();
                }
            });
        }       
    }
}